export enum DockLocationOptions {
  MIDDLE = 'MIDDLE',
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
  BOTTOM = 'BOTTOM',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  TOP_LEFT = 'TOP_LEFT',
  TOP = 'TOP',
}

export enum ImageResizeOptions {
  CROP = 'crop',
  FIT = 'fit',
}

export enum ImageShapeOptions {
  SQUARE = 'square',
  ROUND = 'round',
  RECTANGLE = 'rectangle',
}

export enum ImageSizeOptions {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type Point = {
  x: number;
  y: number;
};

export type LoadedAsyncComponentData<T> = {
  data: T;
  status: AsyncComponentDataStatus.IDLE;
};

export type LoadingAsyncComponentData<T> = {
  status: AsyncComponentDataStatus.LOADING;
  data?: T;
};

type ErrorAsyncComponentData = {
  status: AsyncComponentDataStatus.ERROR;
  data?: never | unknown;
};

export type AsyncComponentData<T> =
  | LoadedAsyncComponentData<T>
  | LoadingAsyncComponentData<T>
  | ErrorAsyncComponentData;

export enum AsyncComponentDataStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  ERROR = 'error',
}

export enum AlignmentOptions {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum BorderStyle {
  BOX = 'box',
  UNDERLINE = 'underline',
}

export enum Preset {
  INQUIRY_SERVICES_PAGE = 'INQUIRY_SERVICES_PAGE',
  INQUIRY_SERVICES_WIDGET = 'INQUIRY_SERVICES_WIDGET',
}

export enum WidgetLayoutOptions {
  GRID = 'grid',
  LIST = 'list',
  SIDE_BY_SIDE = 'sideBySide',
  ON_IMAGE = 'onImage',
}

export enum ListLayoutStyleOptions {
  STRIP = 'strip',
  CARD = 'card',
}

export enum ImagePositionOptions {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum VerticalAlignmentOptions {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom',
}
